<script>
    import TripleCheckbox from '@/components/base-components/TripleCheckbox.vue';

    export default {
        computed: {
            selectAssetType() { return this.$store.getters.MULTI_EDIT_ASSET_TYPE },
            addFilter() { return this.$store.getters.MULTI_EDIT_ADD_FILTER },
            removeFilter() { return this.$store.getters.MULTI_EDIT_REMOVE_FILTER },
            filters() { return this.$store.getters.FILTERS_NO_CHILD(this.selectAssetType)},
        },
        components: {
            TripleCheckbox: TripleCheckbox,
        },
        data() {
            return {
                queries: {},
            }
        },
        methods: {
            // Inline option-search for groups with many items (e.g. Theme).
            showSearch(filterValue) {
                return Array.isArray(filterValue['filter_items'])
                    && filterValue['filter_items'].length > 10;
            },
            setQuery(filterId, value) {
                this.queries[filterId] = value;
            },
            isItemSelected(filterValue, item) {
                const key = `checkbox-${filterValue['id']}-${item['id']}`;
                return this.addFilter.includes(key) || this.removeFilter.includes(key);
            },
            visibleItems(filterValue) {
                const items = filterValue['filter_items'] || [];
                const query = (this.queries[filterValue['id']] || '').trim().toLowerCase();
                if (query === '') return items;
                return items.filter((item) =>
                    String(item['name']).toLowerCase().includes(query)
                    || this.isItemSelected(filterValue, item)
                );
            },
            async updateFilter(event, isAdd = true) {
                await this.setFilter(
                    event.target.checked, 
                    event.target.value, 
                    isAdd
                );
            },
            async setFilter (state, value, isAdd = true) {
                const targetArray = isAdd === true ? this.addFilter : this.removeFilter;

                if (state === true) {
                    targetArray.push(value);
                } 
                else {
                    const itemIndex = targetArray.indexOf(value);
                    if (itemIndex >= 0) targetArray.splice(itemIndex, 1);
                }
            }
        }
    }
</script>


<template>
    <div class="left_filter_list">
        <div 
            v-for="(filterValue, filterIndex) in filters" :key="filterIndex"
            class="left_filter_container"
        >
            <div class="left_filter_header">
                <label>{{ filterValue['name'] }}</label>
            </div>
            <input
                v-if="showSearch(filterValue)"
                class="left_filter_search"
                type="text"
                :value="queries[filterValue['id']] || ''"
                @input="setQuery(filterValue['id'], $event.target.value)"
                :placeholder="`Search ${filterValue['name']}…`"
            >
            <div class="left_filter_body">
                <label
                    v-if="filterValue['is_multiple'] === false && filterValue['is_required'] === false"
                >
                    <input 
                        type="checkbox" 
                        class="mr_5"
                        @click="updateFilter"
                        :checked="addFilter.includes(`none-${filterValue['id']}`)"
                        :value="`none-${filterValue['id']}`"
                    >
                    None
                </label>
                <div v-for="itemValue in visibleItems(filterValue)" :key="itemValue['id']">
                    <input 
                        v-if="filterValue['is_multiple'] === false"
                        :checked="addFilter.includes(`checkbox-${filterValue['id']}-${itemValue['id']}`)"
                        type="checkbox" 
                        @click="updateFilter($event, true)"
                        :value="`checkbox-${filterValue['id']}-${itemValue['id']}`"
                        :id="`m-${filterValue['id']}-${itemValue['id']}`"
                    >
                    <TripleCheckbox 
                        v-else
                        :checkboxValue="`checkbox-${filterValue['id']}-${itemValue['id']}`"
                        :checkboxID="`m-${filterValue['id']}-${itemValue['id']}`"
                        :removeFilter="removeFilter"
                        :addFilter="addFilter"
                        :clickMethod="setFilter"
                    />
                    <label 
                        class="mr_5 ml_5"
                        :for="`m-${filterValue['id']}-${itemValue['id']}`"
                    >{{ itemValue['name'] }}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .left_filter_search {
        box-sizing: border-box;
        width: calc(100% - 10px);
        margin: 5px;
        padding: 4px 8px;
        border: 1px solid var(--header-separator);
        border-radius: 4px;
        background-color: transparent;
        color: var(--filter-header-text);
        font-size: 0.9em;
    }
</style>
